// extracted by mini-css-extract-plugin
export default {"fileName":"FileProgress_fileName__N33Xl","fileSize":"FileProgress_fileSize__mrC0y","fileProgress":"FileProgress_fileProgress__A3mYB"};